import { useState, useEffect } from 'react';

export const useSafeViewportHeight = () => {
  const [height, setHeight] = useState('100vh');

  useEffect(() => {
    const updateHeight = () => {
      // Use visualViewport if available (better for mobile browsers)
      const vh = window.visualViewport?.height || window.innerHeight;
      setHeight(`${vh}px`);
    };

    updateHeight();
    
    // Listen to both resize and visualViewport events
    window.addEventListener('resize', updateHeight);
    window.visualViewport?.addEventListener('resize', updateHeight);
    window.visualViewport?.addEventListener('scroll', updateHeight);
    
    return () => {
      window.removeEventListener('resize', updateHeight);
      window.visualViewport?.removeEventListener('resize', updateHeight);
      window.visualViewport?.removeEventListener('scroll', updateHeight);
    };
  }, []);

  return height;
};